import ApiService from '@/common/api.service'

const RESOURCE = 'settings'
const RESOURCE_OTHER = 'other_settings'
const SettingsService = {
  get (id) {
    return ApiService.getCustomResource(RESOURCE + '/' + id)
  },
  query () {
    return ApiService.getCustomResource(RESOURCE)
  },
  update (id, params) {
    return ApiService.update(RESOURCE, id, params)
  },
  getBirthDayTag (params) {
    const url = '/birthday_tags/'
    return ApiService.get(RESOURCE_OTHER + url + params.month, params.setting_id)
  },
  importTag (params) {
    ApiService.setHeaderImage('multipart/form-data')
    const url = '/birthday_tags/csv'
    return ApiService.post(RESOURCE_OTHER + url, params)
  },
  exportTag (params) {
    const url = '/birthday_tags/csv'
    return ApiService.query(RESOURCE_OTHER + url, params)
  },
  getAllOperatorAuthentic () {
    return ApiService.getCustomResource(`${RESOURCE}/allOperatorAuthentic`)
  }
}
export default SettingsService
